/**
 * Simple dropdown for selecting a Warranty from Master Data.
 *
 * Props:
 *   value     – warranty_id (string)
 *   onChange  – (warrantyId: string, warrantyName: string|null) => void
 *   warranties – array of warranty records [{ id, name, active }]
 *   testId
 *   disabled
 */
export const WarrantyDropdown = ({
  value,
  onChange,
  warranties = [],
  testId,
  disabled = false,
}) => {
  const activeOnly = warranties.filter(w => w.active !== false);
  // Always include the currently-selected warranty even if it's now inactive
  const list = (() => {
    if (value && !activeOnly.some(w => w.id === value)) {
      const found = warranties.find(w => w.id === value);
      return found ? [...activeOnly, found] : activeOnly;
    }
    return activeOnly;
  })();

  const handleChange = (e) => {
    const id = e.target.value;
    const w = warranties.find(x => x.id === id);
    onChange(id, w ? w.name : null);
  };

  return (
    <select
      value={value || ''}
      onChange={handleChange}
      disabled={disabled}
      data-testid={testId}
      className="w-full px-2 py-1.5 border border-slate-200 rounded-sm text-sm bg-white focus:border-orange-500 focus:outline-none disabled:bg-slate-50 disabled:cursor-not-allowed"
    >
      <option value="">-- Warranty --</option>
      {list.map(w => (
        <option key={w.id} value={w.id}>
          {w.name}{w.active === false ? ' (inactive)' : ''}
        </option>
      ))}
    </select>
  );
};
